<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-light`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.3828 7.1604C10.8086 6.73228 11.0215 6.51822 11.0356 6.33454C11.0478 6.17514 10.9831 6.01951 10.8615 5.91578C10.7213 5.79625 10.4194 5.79625 9.81555 5.79625H9.33525C9.00018 5.79625 8.83264 5.79625 8.7154 5.7274C8.61257 5.667 8.53471 5.57185 8.49587 5.4591C8.45159 5.33055 8.48475 5.16633 8.55108 4.83788L9.00284 2.60096C9.15248 1.85999 9.2273 1.48951 9.12231 1.32091C9.03154 1.17515 8.87233 1.08617 8.70063 1.08522C8.50202 1.08413 8.22565 1.34197 7.67293 1.85765L3.07795 6.14463C2.61548 6.57611 2.38425 6.79184 2.36501 6.97827C2.34834 7.13991 2.41125 7.29958 2.53371 7.40639C2.67496 7.52958 2.9912 7.52958 3.6237 7.52958H4.55277C4.88694 7.52958 5.05402 7.52958 5.17112 7.59821C5.27382 7.65841 5.35168 7.75327 5.39069 7.86575C5.43517 7.99398 5.40258 8.15786 5.33741 8.48561L4.92281 10.5706C4.7674 11.3522 4.68969 11.743 4.79853 11.9127C4.89255 12.0593 5.05607 12.1464 5.23018 12.1426C5.43174 12.1383 5.71272 11.8558 6.27466 11.2908L10.3828 7.1604Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillLight',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
